import script from "./VerifyEmailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&setup=true&lang=js"

import "./VerifyEmailPage.vue?vue&type=style&index=0&id=cc913376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc913376"]])

export default __exports__